"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPredicate = void 0;
const equal_operation_1 = require("../expression-tree/nodes/equal-operation");
const greater_than_operation_1 = require("../expression-tree/nodes/greater-than-operation");
const greater_than_or_equal_operation_1 = require("../expression-tree/nodes/greater-than-or-equal-operation");
const less_than_operation_1 = require("../expression-tree/nodes/less-than-operation");
const less_than_or_equal_operation_1 = require("../expression-tree/nodes/less-than-or-equal-operation");
const match_operation_1 = require("../expression-tree/nodes/match-operation");
const not_equal_operation_1 = require("../expression-tree/nodes/not-equal-operation");
const not_match_operation_1 = require("../expression-tree/nodes/not-match-operation");
const not_subset_operation_1 = require("../expression-tree/nodes/not-subset-operation");
const not_superset_operation_1 = require("../expression-tree/nodes/not-superset-operation");
const subset_operation_1 = require("../expression-tree/nodes/subset-operation");
const superset_operation_1 = require("../expression-tree/nodes/superset-operation");
const create_atom_1 = require("./create-atom");
function createPredicate(predicateTuple) {
    switch (predicateTuple[1]) {
        case '==':
            return new equal_operation_1.EqualOperation(create_atom_1.createAtom(predicateTuple[0]), create_atom_1.createAtom(predicateTuple[2]));
        case '!=':
            return new not_equal_operation_1.NotEqualOperation(create_atom_1.createAtom(predicateTuple[0]), create_atom_1.createAtom(predicateTuple[2]));
        case '<':
            return new less_than_operation_1.LessThanOperation(create_atom_1.createAtom(predicateTuple[0]), create_atom_1.createAtom(predicateTuple[2]));
        case '<=':
            return new less_than_or_equal_operation_1.LessThanOrEqualOperation(create_atom_1.createAtom(predicateTuple[0]), create_atom_1.createAtom(predicateTuple[2]));
        case '>':
            return new greater_than_operation_1.GreaterThanOperation(create_atom_1.createAtom(predicateTuple[0]), create_atom_1.createAtom(predicateTuple[2]));
        case '>=':
            return new greater_than_or_equal_operation_1.GreaterThanOrEqualOperation(create_atom_1.createAtom(predicateTuple[0]), create_atom_1.createAtom(predicateTuple[2]));
        case '=~':
            return new match_operation_1.MatchOperation(create_atom_1.createAtom(predicateTuple[0]), create_atom_1.createAtom(predicateTuple[2]));
        case '!~':
            return new not_match_operation_1.NotMatchOperation(create_atom_1.createAtom(predicateTuple[0]), create_atom_1.createAtom(predicateTuple[2]));
        case '@<':
            return new subset_operation_1.SubsetOperation(create_atom_1.createAtom(predicateTuple[0]), create_atom_1.createAtom(predicateTuple[2]));
        case '!@<':
            return new not_subset_operation_1.NotSubsetOperation(create_atom_1.createAtom(predicateTuple[0]), create_atom_1.createAtom(predicateTuple[2]));
        case '@>':
            return new superset_operation_1.SupersetOperation(create_atom_1.createAtom(predicateTuple[0]), create_atom_1.createAtom(predicateTuple[2]));
        case '!@>':
            return new not_superset_operation_1.NotSupersetOperation(create_atom_1.createAtom(predicateTuple[0]), create_atom_1.createAtom(predicateTuple[2]));
    }
}
exports.createPredicate = createPredicate;
//# sourceMappingURL=create-predicate.js.map